<template>
  <el-dialog
      :visible.sync="visible"
      title="设置发货计划"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="80%"
  >
    <el-form :model="dataForm" ref="dataForm" label-width="120px">
      <div class="table-bar" style="margin-bottom: 10px;">
        <div style="display: flex;align-items: center">
          <el-form-item label="外销合同编号：" style="margin-bottom: 0;">
            <order-drop v-model="orderCode" size="mini" placeholder="请选择外销合同编号"></order-drop>
          </el-form-item>
          <tool-tip v-if="!orderCode" style="margin-left: 10px;">请选择外销合同</tool-tip>
        </div>
        <div v-if="orderCode">
          <el-date-picker
              v-model="planDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="margin-right: 20px"
              placeholder="选择发货日期"
              size="mini"
          >
          </el-date-picker>
          <el-button
              size="mini"
              icon="el-icon-plus"
              @click="addRow()"
              type="primary"
          >添加计划
          </el-button
          >
        </div>
      </div>

      <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
          ref="table"
          max-height="500"
      >
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="品番号" width="230" prop="code" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="SKU" width="220" prop="skuCode" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="品名" width="230" align="center" prop="name">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
            width="100"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="size"
            header-align="center"
            align="center"
            width="100"
        >
        </el-table-column>
        <el-table-column
            label="合同数量"
            header-align="center"
            align="center"
            prop="count"
        >
        </el-table-column>
        <el-table-column
            v-for="(column, index) in planList"
            :key="index"
            :label="column"
            header-align="center"
            align="center"
            width="160"
        >
          <template slot="header" slot-scope="scope">
            <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
            >
              <div style="height: 18px; vertical-align: bottom">
                {{ scope.column.label }}
              </div>
              <i
                  class="el-icon-error"
                  style="
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                    margin-left: 10px;
                  "
                  @click="removePlan(scope.column)"
              ></i>
            </div>
          </template>
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.' + scope.column.label"
                :rules="detailRule.count"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row[column]"
                  @change="reComputedLimitCount"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="剩余数量"
            header-align="center"
            align="center"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.limitCount > 0 ? 'danger' : 'success'">{{
                scope.row.limitCount
              }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template #footer>
      <el-button @click="cancel()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import SaveRule from './save-rule'
import BigNumber from 'bignumber.js'
export default {
  mixins: [SaveRule],
  components: {},
  data () {
    return {
      orderCode: '',
      visible: false,
      planDate: '',
      dataForm: { agreementId: '', detailList: [] },
      currentDetailIndex: {},
      planList: [],
    }
  },
  watch: {
    orderCode: {
      handler: function (newVal) {
        if(newVal){
          this.getOrderDetail()
        }else{
          this.dataForm.detailList=[]
          this.dataList = []
          this.planList = []
        }

      },
      immediate: true
    }
  },
  methods: {
    init () {
      this.reset()
      this.visible = true
    },
    async getOrderDetail () {
      const { data: res } = await this.$http.get(`/trade/agreement/detail/list`, { params: { agreementCode: this.orderCode } })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      }
      this.dataList = []
      this.planList = []
      let tmp = res.data.map(row => {
        return {
          id: row.id,
          code: row.code,
          skuCode: row.skuCode,
          name: row.name,
          color: row.color,
          size: row.size,
          count: row.count,
          limitCount:row.count
        }
      })
      this.$set(this.dataForm, 'detailList', tmp)
      this.getPlanList()
    },
    async getPlanList () {
      const { data: res } = await this.$http.get(`/trade/plan/list`, { params: { orderCode: this.orderCode } })
      if (res.data) {
        let tmpPlan = []
        res.data.forEach((plan) => {
          if (tmpPlan.find((m) => m == plan.sendDate)) {
            return
          }
          tmpPlan.push(plan.sendDate)
        })
        this.planList = tmpPlan
        this.planList.forEach((plan) => {
          this.dataForm.detailList.forEach((item) => {
            const planInfo = res.data.find(
                (m) => m.sendDate === plan && m.agreementDetailId === item.id
            )
            this.$set(item, plan, planInfo ? planInfo.count : 0)
          })
        })
        this.reComputedLimitCount()
      }
    },
    removePlan (column) {
      for (let i = this.planList.length - 1; i >= 0; i--) {
        let item = this.planList[i]
        if (item === column.label) {
          this.planList.splice(i, 1)
        }
      }
      this.dataForm.detailList.forEach((row) => {
        this.$delete(row, column.label)
      })
      this.reComputedLimitCount()
    },
    reComputedLimitCount () {
      this.dataForm.detailList.forEach((row) => {
        let sendCount = new BigNumber(0)
        this.planList.forEach((plan) => {
          if (!row[plan]) {
            return
          }
          let tc = new BigNumber(row[plan])
          if (!tc.isInteger) {
            return
          }
          sendCount = sendCount.plus(tc)
        })
        row.limitCount = row.count - sendCount.toNumber()
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach((item) => {
        item.limitCount = item.count
      })
    },
    afterTableBinding (dataList) {
      this.dataForm.detailList = dataList
      this.getPlanList()
    },

    addRow () {
      if (!this.planDate) {
        return this.$message.error('请先选择发货日期')
      }
      if (this.planList.find((item) => item === this.planDate)) {
        return this.$message.error('计划日期重复')
      }
      this.planList.push(this.planDate)
      this.dataForm.detailList.forEach((item) => {
        this.$set(item, this.planDate, 0)
      })
    },
    reset () {
      this.dataList = []
      this.planList = []
      this.orderCode = ''
      this.dataForm.planDate = ''
      this.dataForm.agreementId = ''
      this.dataForm.detailList = []
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].resetFields()
        }
      })
    },
    cancel () {
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            this.reComputedLimitCount()
            //判断是否有剩余未发货
            for (let i = 0; i < this.dataForm.detailList.length; i++) {
              const item = this.dataForm.detailList[i]
              if (item.limitCount > 0) {
                return this.$message.error('有货物未设置发货计划')
              }
            }
            let postForm = []
            this.planList.forEach((plan) => {
              this.dataForm.detailList.forEach((item) => {
                postForm.push({
                  agreementDetailId: item.id,
                  sendDate: plan,
                  count: item[plan],
                })
              })
            })
            const loading = this.$loading()
            this.$http
                .post('/trade/plan/save', postForm)
                .then(({ data: res }) => {
                  loading.close()
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.$router.push(`/trade-agreement-index`)
                    },
                  })
                })
                .catch((e) => {
                  console.log(e)
                  loading.close()
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
